document.addEventListener('DOMContentLoaded', () => {
  console.log('custom.js');

  /* fix-reserve-modal */
  const modal = document.querySelector('.js-fix-reserve-modal');
  const openBtn = document.querySelectorAll('.js-fix-reserve-modal-open');
  const closeBtn = document.querySelectorAll('.js-fix-reserve-modal-close');
  if (!modal || !openBtn || !closeBtn) return;
  openBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      modal.classList.add('is-open');
    });
  });
  closeBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      modal.classList.remove('is-open');
    });
  });
});